import React from "react";
import { observer, inject } from "mobx-react";
import injectSheet from "react-jss";
import DevTools from "mobx-react-devtools";
import ErrorPage from "../Errorpage.jsx";
import StatisticsBox from "../../components/StatisticsBox";
import TwitchTable from "../../components/TwitchTable";
import EmotesBar from "../../components/emotesBar/EmotesBar";
import Chatters from "../../components/ChattersTable";
import BttvEmotes from "../../components/BttvEmotes";
import FfzEmotes from "../../components/FfzEmotes";
import SevenTVEmotes from "../../components/7tvEmotes";
import Commands from "../../components/CommandTable";
import ChannelSelector from "../../components/channelSelector/ChannelSelector";
import ConnectBanner from "../../components/banner/ConnectBanner";
import BannerV2 from "../../components/bannerV2/BannerV2";

@inject("store")
@observer
class ChatStats extends React.Component {
  componentDidMount() {
    this.handleChannelUpdate();
  }

  handleChannelUpdate() {
    const {
      match: {
        params: { channel = "global" },
      },
    } = this.props;
    this.props.store.onChangeChannel(channel);
  }

  componentWillReact() {
    const {
      match: {
        params: { channel = "global" },
      },
    } = this.props;
    if (channel !== this.props.store.channel) {
      this.handleChannelUpdate();
    }
  }

  render() {
    const { classes, store } = this.props;
    const { is404 } = store;

    if (is404) {
      return <ErrorPage />;
    }
    return (
      <div className={`${classes.chatStats} ${classes.layoutColumnXs}`}>
        <BannerV2 />
        <EmotesBar />
        {/*<DevTools/>*/}
        <div
          className={`${classes.layoutRow} ${classes.layoutAlignStart} ${classes.layoutAlignCenterStartXs} ${classes.layoutColumnXs} ${classes.layoutWrapMd}`}
        >
          <ChannelSelector />
          <div
            className={`${classes.tablesWrapper} ${classes.layoutRow} ${classes.layoutWrap} ${classes.layoutColumnXs} ${classes.layoutAlignSpaceBetween} ${classes.layoutAlignCenterXs}`}
          >
            <StatisticsBox type="totalMessages" />
            <StatisticsBox type="messagesPerSecond" />
            <Chatters />
            <TwitchTable />
            <SevenTVEmotes />
            <BttvEmotes />
            <FfzEmotes />
            <Commands />
          </div>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  chatStats: {
    maxWidth: theme.pages.maxWidth,
    margin: "0 auto",
    backgroundColor: theme.backgrounds.page,
    paddingBottom: theme.spacing * 4,
    paddingLeft: theme.spacing * 3,
    paddingRight: theme.spacing * 3,
  },
  layoutRow: {
    display: "flex",
    flexDirection: "row",
  },
  layoutColumnXs: {
    [theme.devices.small]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  layoutWrapMd: {
    [theme.devices.large]: {
      flexWrap: "wrap",
    },
  },
  layoutWrap: {
    flexWrap: "wrap",
  },
  layoutAlignSpaceBetween: {
    justifyContent: "space-between",
  },
  layoutAlignStart: {
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  layoutAlignCenterXs: {
    [theme.devices.small]: {
      justifyContent: "center",
    },
  },
  layoutAlignCenterStartXs: {
    [theme.devices.small]: {
      justifyContent: "flex-start",
      alignItems: "center",
    },
  },
  tablesWrapper: {
    width: "100%",
  },
  notfoundWrapper: {
    textAlign: "center",
    marginTop: 97,
  },
  notfoundText: {
    fontSize: 28,
  },
  notfoundImage: {
    display: "block",
    margin: "auto",
    marginBottom: 24,
  },
});

export default injectSheet(styles)(ChatStats);



// WEBPACK FOOTER //
// ./src/app/pages/chatstats/ChatStats.js